import React from 'react';

import { Button, Modal, ModalBody, ModalHeader } from '@change/ds-core-ui';

import { TranslatePlural, useI18n } from '@change-corgi/core/react/i18n';

import type { LegislativeBody } from '../../../shared/types';
import { BodyContent } from '../BodyContent';

import { useViewMore } from './hooks/useViewMore';

export const ViewMore: React.FC<{ legislativeBody: LegislativeBody }> = ({ legislativeBody }) => {
	const { title, viewMoreCount, allDMs } = legislativeBody;

	const {
		data: { petitionAsk },
		actions: { trackViewAllDMsWithinLegislativeBodyClick },
	} = useViewMore();

	const { translate } = useI18n();

	return (
		<Modal
			size="large"
			onClose={() => {}}
			trigger={
				<Button
					data-qa="legislative-bodies-view-more"
					variant="tertiary"
					onClick={() => trackViewAllDMsWithinLegislativeBodyClick(title)}
				>
					<TranslatePlural
						value="corgi.petition_gamma.decision_makers_v2.legislative_body.view_more.trigger"
						replacements={{ extraMembersCount: viewMoreCount }}
						count={viewMoreCount}
					/>
				</Button>
			}
			className="z-[5000] lg:[&_*]:!col-span-full"
		>
			<ModalHeader
				title={translate('corgi.petition_gamma.decision_makers_v2.legislative_body.view_more.title', {
					legislativeBodyTitle: title,
				})}
				subtitle={petitionAsk}
			/>
			<ModalBody className="!max-h-none p-6">
				<BodyContent legislativeBody={{ ...legislativeBody, viewMoreCount: 0, displayedDMs: allDMs }} />
			</ModalBody>
		</Modal>
	);
};
